/**
 * features/hr/MedicalAid.tsx
 * ------------------------------------------------------------------
 * One nav home for staff medical aid. Enter a staff member's scheme,
 * membership and premium; the employee share is split out and deducted
 * on payroll every month (open-ended — no running balance).
 * ------------------------------------------------------------------
 */
import DeductionEntry from '@/features/hr/DeductionEntry';
import { PageHeader } from '@/components/ui/primitives';

export default function MedicalAid({
  onOpenStaff,
}: {
  onOpenStaff?: (id: string) => void;
}) {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Medical Aid"
        subtitle="Record each staff member's medical scheme. The employee contribution is deducted on payroll every month."
      />
      <DeductionEntry type="medical_aid" onOpenStaff={onOpenStaff} />
    </div>
  );
}
